import { render } from "./geo-payment-methods-list.vue?vue&type=template&id=5116a346&ts=true"
import script from "./geo-payment-methods-list.ts?vue&type=script&lang=ts"
export * from "./geo-payment-methods-list.ts?vue&type=script&lang=ts"

import "./geo-payment-methods-list.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__